import { ComboItem } from '../../../../model';
import { PaisEditIn, PaisEditOut } from '../../../../model/seguridad';
import Common, { Stores } from '../../../common';
import { IPaginatedResponse, IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';
import { IPais } from '../model';

export default class PaisService extends ServiceBase {
  
  getEdit = (data:{ user?: string, id?: number }) => this.GetFetch<IResponse<PaisEditOut>>('entity/pais/edit', data);

  combo = (data:{ activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<IResponse<ComboItem[]>>('entity/pais/combo', data);

  upsert = (data:PaisEditIn) => this.PostFetch<IResponse<number>>('entity/pais', data);


  
  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, codigo?: string, nombre?: string, moneda?: string, activo?: boolean }) : Promise<IPaginatedResponse<IPais>> => 
    this.GetFetch<IPaginatedResponse<IPais>>('entity/pais/find', data);

  all = () : Promise<IResponse<IPais[]>> => 
    Common.indexedDB.StoreControl.apiget(Stores.Paises, () => this.GetFetch<IResponse<IPais[]>>('entity/pais/all', {}));
  

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/pais', data);  
}
